import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getById(id) {
    const department = id ? `?department_id=${id}` : "";
    return api.get(`/api/v1/user/tree${department}`);
  },
};
